import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { General } from "../../siteManagement/general";
import { Sheet, SheetEventType } from "../../siteManagement/sheet";
import React from "react";
export default class EditCategorieApp extends React.Component<EditCategorieProps, any> {
    common = new AppHelper();

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }

    save = (closeAfterSave) => {
        HTTPService.post<JsonResultClass<EntityIndKat>>("IndividualCategory/Save", { indKatViewModel: this.props.entity }).then(result => {
            if (result.Code === 0) {
                this.props.entity.IsNew = false;
                this.props.entity.Id = result.Data.Id;
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, closeAfterSave);
            this.setState({});
        });
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.KatName":
                this.props.entity.KatName = value;
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} titleProps={""} />;
    }
}

export interface EditCategorieProps extends AppBaseProps {
    entity: EntityIndKat;
    translations: {};
}

export interface EntityIndKat extends Entity {
    Id: number;
    Tabelle: string;
    KatName: string;
    Pos: number;
}